<template>
  <a-card :bordered="false">
    <a-table :columns="columns" :row-key="record => record.id" :data-source="data" :pagination="pagination"
      :loading="loading" @change="handleTableChange">
      <span slot="create_time" slot-scope="text">
        {{ text | dayjs }}
      </span>
    </a-table>
  </a-card>
</template>
<script>

import { emailLog } from '@/api/email'

const columns = [
  {
    title: '类型',
    dataIndex: 'type',
    filters: [
      { text: 'Admin', value: 'admin' },
      { text: 'System', value: 'system' },
      { text: 'User', value: 'user' },
      { text: 'Teacher', value: 'teacher' }
    ]
  },
  {
    title: '主题',
    dataIndex: 'subject'
  },
  {
    title: 'To',
    dataIndex: 'to'
  },
  {
    title: 'CC',
    dataIndex: 'cc'
  },
  {
    title: 'BCC',
    dataIndex: 'bcc'
  },
  {
    title: '内容',
    dataIndex: 'message',
    ellipsis: true
  },
  {
    title: '返回',
    dataIndex: 'result'
  },
  {
    title: '发送时间',
    dataIndex: 'create_time',
    sorter: true,
    scopedSlots: { customRender: 'create_time' }
  }
]

export default {
  name: 'ClientEmail',
  props: {
    clientId: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      data: [],
      pagination: {},
      loading: false,
      columns
    }
  },
  mounted() {
    this.queryParam = { type: 'user', relid: this.clientId }
    this.fetch(this.queryParam)
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination)
      const pager = { ...this.pagination }
      pager.current = pagination.current
      // 带上查询参数
      const queryParam = this.queryParam
      this.pagination = pager
      this.fetch({
        results: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortOrder: sorter.order,
        ...filters,
        ...queryParam
      })
    },
    fetch(params = {}) {
      this.loading = true
      new Promise((resolve, reject) => {
        emailLog(params).then(response => {
          if (response.status === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
      }).then(res => {
        const data = res.data
        const pagination = { ...this.pagination }
        this.loading = false
        this.data = data.data
        pagination.total = data.total
        pagination.pageSize = data.per_page
        pagination.current = data.current_page
        this.pagination = pagination
      })
    }
  }
}
</script>
